var path = '/var/www/mmscny-cms/src/app/common/components/character-count/character-count.html';
var html = "<span class=character-count>{{$ctrl.maxCount - $ctrl.input.length}} out of {{$ctrl.maxCount}} Characters left</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/character-count/character-count.html
// module id = 712
// module chunks = 0